export default __webpack_public_path__ + "static/media/connectionUncertain.3d514ef4.svg";